// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__xMuJR","footerTopWrapper":"Footer_footerTopWrapper__6UKMN","footerBtmWrapper":"Footer_footerBtmWrapper__C464r","footerTitle":"Footer_footerTitle__1qwkd"};